import { Mark, mergeAttributes } from '@tiptap/react';

declare module '@tiptap/react' {
  interface Commands<ReturnType> {
    cloze: {
      setCloze: (attrs?: { group?: number }) => ReturnType;
      toggleCloze: (attrs?: { group?: number }) => ReturnType;
      unsetCloze: () => ReturnType;
    };
  }
}

export const Cloze = Mark.create<{ defaultGroup: number }>({
  name: 'cloze',

  addOptions() {
    return { defaultGroup: 1 };
  },

  addAttributes() {
    return {
      group: {
        default: 1,
        parseHTML: (el) => Number(el.getAttribute('data-cloze') ?? 1),
        renderHTML: (attrs) => ({ 'data-cloze': attrs.group }),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-cloze]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes, { class: 'cloze' }), 0];
  },

  addCommands() {
    return {
      setCloze:
        (attrs) =>
        ({ commands }) =>
          commands.setMark(this.name, { group: attrs?.group ?? this.options.defaultGroup }),
      toggleCloze:
        (attrs) =>
        ({ commands }) =>
          commands.toggleMark(this.name, { group: attrs?.group ?? this.options.defaultGroup }),
      unsetCloze:
        () =>
        ({ commands }) =>
          commands.unsetMark(this.name),
    };
  },

  addKeyboardShortcuts() {
    return {
      'Mod-Shift-c': () => this.editor.commands.toggleCloze(),
    };
  },
});
